import { makeAutoObservable } from "mobx";
import Api_v1 from "../../api/Api_v1";
import Api_v2 from "../../api/Api_v2";
import { ConfigApi } from "../../api/base/ConfigApi";

class ApiStore {
  Api_v1!: Api_v1;
  Api_v2!: Api_v2;

  configApi: ConfigApi = {} as ConfigApi;
  constructor(configApi: ConfigApi) {
    makeAutoObservable(this);
    this.configApi = configApi;
    this.Api_v1 = new Api_v1(configApi);
    this.Api_v2 = new Api_v2(configApi);
  }
}
export default ApiStore;
